import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { AbstractFinanceFromComponent } from '../abstract-v12-retail-finance-from.component';
@Component({
    selector: 'v12-retail-finance-from-basket',
    templateUrl: 'v12-retail-finance-from-basket.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ICmsClientModule]
})
export class FinanceFromBasketComponent extends AbstractFinanceFromComponent {
}
